var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "https://lottiefiles.com/animations/success-6FdewB9DKj",
    clipPath: "url(#clip0_26_1302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_1302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_5062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_1302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.948675
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.3356 20.2629C82.101 20.2629 99.7729 37.9348 99.7729 59.7001C99.7729 81.4655 82.101 99.1374 60.3356 99.1374C38.5703 99.1374 20.8984 81.4655 20.8984 59.7001C20.8984 37.9348 38.5703 20.2629 60.3356 20.2629Z",
    fill: "#3EEA0F",
    fillOpacity: 0.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.611227
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.9847 7.06311C89.261 7.06311 113.031 30.8331 113.031 60.1094C113.031 89.3856 89.261 113.156 59.9847 113.156C30.7085 113.156 6.93848 89.3856 6.93848 60.1094C6.93848 30.8331 30.7085 7.06311 59.9847 7.06311Z",
    fill: "#3EEA10",
    fillOpacity: 0.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.5506 28.3485C77.7152 28.3485 91.6515 42.2848 91.6515 59.4494C91.6515 76.614 77.7152 90.5503 60.5506 90.5503C43.386 90.5503 29.4497 76.614 29.4497 59.4494C29.4497 42.2848 43.386 28.3485 60.5506 28.3485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.5506 28.3485C77.7152 28.3485 91.6515 42.2848 91.6515 59.4494C91.6515 76.614 77.7152 90.5503 60.5506 90.5503C43.386 90.5503 29.4497 76.614 29.4497 59.4494C29.4497 42.2848 43.386 28.3485 60.5506 28.3485Z",
    stroke: "#3EEA10",
    strokeWidth: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26_1302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 46,
    width: 29,
    height: 24
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_5064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.1197 53.2568L46.5142 58.1421L57.4545 69.977L74.3189 52.0717L68.5077 46.2781L56.7665 57.5917L53.1197 53.2568Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26_1302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70.2776 50.6047L57.6237 63.2025L52.7009 58.3112L50.9868 59.9686L57.5422 66.5554L71.798 52.2809L70.2776 50.6047Z",
    fill: "#3EEA10"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationSuccessIcon);
export default __webpack_public_path__ + "static/media/creation-success-icon.b4b3a50d5c11efd48911f95f42b07b8b.svg";
export { ForwardRef as ReactComponent };